import React from "react";
import NoContent from "../NoContent/NoContent";

interface ComingSoonProps {
  title: string;
  message: string;
  imageUrl: string;
  learnMoreUrl: string;
}

const ComingSoon = ({ title, message, imageUrl, learnMoreUrl }: ComingSoonProps) => {
  return (
    <NoContent
      imageSrc={imageUrl}
      imageAlt="Coming soon illustration"
      title={title}
      description={message}
      buttonText="Learn More"
      buttonUrl={learnMoreUrl}
      buttonWidth="full"
    />
  );
};

export default ComingSoon;
